import React from 'react';
import Testimonials from '../components/Testimonials';
import PageHero from '../components/PageHero';
import SEO from '../components/SEO';
import { useLanguage } from '../context/LanguageContext';
import { SITE_URL } from '../config/site';
import './PageStyles.css';

const TestimonialsPage = () => {
  const { t } = useLanguage();

  return (
    <div className="page-container">
      <SEO
        title="Patient Testimonials | Dr. Muyabins Dental Care"
        description="Read patient reviews and testimonials about dental care experiences at Dr. Muyabins Dental Care in Dar es Salaam, Tanzania."
        keywords="dentist reviews Dar es Salaam, patient testimonials Tanzania, dental clinic reviews"
        url={`${SITE_URL}/testimonials`}
      />
      <PageHero
        title={t('pages.testimonialsTitle')}
        subtitle={t('pages.testimonialsSubtitle')}
        breadcrumb={[
          { label: 'Home', href: '/' },
          { label: t('nav.testimonials') },
        ]}
      />
      <div className="page-content">
        <Testimonials hideHeader />
      </div>
    </div>
  );
};

export default TestimonialsPage;
